




















import { Component, Prop, Vue } from 'vue-property-decorator';
import Checkbox from '@/components/Checkbox/Checkbox.vue';

export type TFlagStatus = 'enabled' | 'disabled' | 'unavailable' | 'partial';
export interface IFeatureFlag {
  dev: TFlagStatus;
  production: TFlagStatus;
  staging: TFlagStatus;
  qa: TFlagStatus;
  name: string;
  slug: string;
  createdAt: string;
}

// Update to get only envs
type TFeatureFlagEnvs = keyof IFeatureFlag;

@Component({
  components: {
    Checkbox
  }
})
export default class FeatureFlagStatus extends Vue {
  @Prop() flag!: IFeatureFlag;
  envs: TFeatureFlagEnvs[] = ['dev', 'qa', 'staging', 'production'];

  titles: Record<TFlagStatus, string> = {
    enabled: 'Enabled for everyone.',
    disabled: 'Disabled for everyone.',
    partial: 'Enabled for specific customers or businesses.',
    unavailable: 'Not published or unavailable.'
  };

  colors: Record<TFlagStatus, string> = {
    enabled: '#6bd65d',
    disabled: '#cfdae6',
    partial: '#ded866',
    unavailable: '#efefef'
  };

  // Workaround to get the current env
  getCurrentEnv() {
    const env = process.env.VUE_APP_ENV as TFeatureFlagEnvs | 'development';

    if (env === 'development') {
      return 'dev';
    }

    return env;
  }

  getTitle(status: string = 'unavailable') {
    return this.titles[status as TFlagStatus];
  }

  getFlagStatusColor(status: string = 'unavailable') {
    return this.colors[status as TFlagStatus];
  }
}
